// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"75ee3749","453":"029dee41","541":"a1113949"}[chunkId] + ".chunk.js";
};